import StringColumn from "@isceco/widget-library2/basic-elements/List/column/StringColumn.js";
import GenericColumn from "@isceco/widget-library2/basic-elements/List/column/GenericColumn.js";
import DateTimeCell from "@isceco/widget-library2/basic-elements/List/cell/DateTimeCell.js";

export default class MonitoringColumns {

  static FILE_TYPE_COLUMN() {
    return new StringColumn({
      key: 'fileType',
      text: 'admin.monitoring.table.fileType',
      sortable: false
    })
  }

  static LAST_FILE_DATE_COLUMN(i18n) {
    return new GenericColumn({
      key: 'lastFileDate',
      text: 'admin.monitoring.table.lastFileDate',
      helpText: () => i18n.translate('admin.monitoring.table.lastFileDate.info'),
      sortable: false,
      cell: new DateTimeCell()
    })
  }

  static ERROR_MESSAGE_COLUMN() {
    return new StringColumn({
      key: 'errorMessage',
      text: 'admin.monitoring.table.errorMessage',
      sortable: false
    })
  }

  static LAST_VALID_FILE_DATE_COLUMN() {
    return new GenericColumn({
      key: 'lastValidFileDate',
      text: 'admin.monitoring.table.lastValidFileDate',
      sortable: false,
      cell: new DateTimeCell()
    })
  }
}
